module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Don’t Worry, He Doesn’t Bite")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#introduction"
    }
  }, [_vm._v("Introduction")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#in-the-beginning-there-was-google"
    }
  }, [_vm._v("In the Beginning, There Was Google")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#the-curious-incident-of-the-budgie-in-the-shoebox"
    }
  }, [_vm._v("The Curious Incident of the Budgie in the Shoebox")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#cats-are-extraordinary-climbers"
    }
  }, [_vm._v("Cats are Extraordinary Climbers")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#anal-glands",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anal Glands")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#the-lethargic-dog",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lethargic Dog")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#expectation-vs-reality",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Expectation vs Reality")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#puppy-boom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Puppy BOOM")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#vaccines-contain-microchipsdont-they",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vaccines Contain Microchips…Don’t They?")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#the-industry-genuinely-does-have-its-perks",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Industry Genuinely Does Have Its Perks")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#the-dog-that-threw-up-more-than-they-could-chew",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dog That Threw Up More Than They Could Chew")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#a-euthanasia-gone-wrong",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Euthanasia Gone Wrong")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#pet-names",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pet Names")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#learning-to-fail-as-a-perfectionist",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Learning to Fail as a Perfectionist")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#covid-brexit-x-puppy-boom-staff-shortages",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Covid + Brexit x Puppy Boom = Staff Shortages")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#unlikely-things-to-hear-in-a-consult-room",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unlikely Things to Hear in a Consult Room")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#christmas-time-toxicities-and-wine",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christmas Time, Toxicities and Wine")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#out-with-the-old-in-with-the-new",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Out with the Old, in with the New")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#fight-or-flight",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fight or Flight")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#my-dogs-actually-on-a-vegan-grain-free-latte-espresso-caramel-diet-with-two-sugars",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Dog’s Actually on a Vegan Grain-Free Latte Espresso Caramel Diet with Two Sugars")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#euthanasia",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Euthanasia")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#one-final-topic",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One Final Topic…")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#charities",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charities")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-246b895e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0